export enum SubscriptionPaymentStatusTypes {
	Pending = 0,
	Succeeded = 1,
	Failed = 2,
	Refunded = 3,
}

const paymentStatusByName: Record<string, SubscriptionPaymentStatusTypes> = {
	Pending: SubscriptionPaymentStatusTypes.Pending,
	Succeeded: SubscriptionPaymentStatusTypes.Succeeded,
	Failed: SubscriptionPaymentStatusTypes.Failed,
	Refunded: SubscriptionPaymentStatusTypes.Refunded,
}

/** API may return enum as number or string name depending on serializer settings. */
export function normalizePaymentStatus(status: SubscriptionPaymentStatusTypes | string | number): SubscriptionPaymentStatusTypes {
	if (typeof status === 'number') return status
	if (typeof status === 'string') {
		if (status in paymentStatusByName) return paymentStatusByName[status]
		const parsed = Number(status)
		if (!Number.isNaN(parsed)) return parsed as SubscriptionPaymentStatusTypes
	}
	return SubscriptionPaymentStatusTypes.Pending
}

export interface SearchAdminTransactionsRequest {
	pageNumber: number
	pageSize: number
	sortField?: string
	sortOrder?: string
	paymentStatus?: SubscriptionPaymentStatusTypes
	dateFrom?: string
	dateTo?: string
	tenantId?: number
	keyword?: string
}

export interface AdminTransactionListResponse {
	id: number
	tenantId: number
	tenantName: string
	tenantAdminEmail: string
	tenantSubscriptionPlanId: number
	planName: string
	amount: number
	currency: string
	paymentStatus: SubscriptionPaymentStatusTypes | string
	stripePaymentIntentId?: string
	invoiceUrl?: string
	purchasedByUserId?: string
	createdOn: string
}

export interface TransactionAnalyticsSummaryResponse {
	totalCount: number
	succeededCount: number
	failedCount: number
	pendingCount: number
	refundedCount: number
	succeededAmount: number
	currency: string
}

export interface PaginationResponse<T> {
	data?: T[]
	totalCount?: number
	currentPage?: number
	pageSize?: number
}
